import { render, staticRenderFns } from "./downloadIcon.vue?vue&type=template&id=37b025e8&scoped=true&lang=pug&"
import script from "./downloadIcon.vue?vue&type=script&lang=js&"
export * from "./downloadIcon.vue?vue&type=script&lang=js&"
import style0 from "./downloadIcon.vue?vue&type=style&index=0&id=37b025e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b025e8",
  null
  
)

export default component.exports